import { Link, Route, Routes } from 'react-router-dom'

import { Layout } from './components/Layout'
import { RipProvider } from './components/RipProvider'
import { FairnessPage } from './pages/Fairness'
import { DashboardPage } from './pages/Dashboard'
import { HomePage } from './pages/Home'
import { LeaderboardPage } from './pages/Leaderboard'
import { MarketPage } from './pages/Market'
import { PackPage } from './pages/Pack'
import { PacksPage } from './pages/Packs'
import { ProfilePage } from './pages/Profile'
import { ReferralsPage } from './pages/Referrals'
import { TokenPage } from './pages/Token'
import { SettingsPage } from './pages/Settings'
import { StudioPage } from './pages/Studio'
import { VaultPage } from './pages/Vault'
import { WalletPage } from './pages/Wallet'

export default function App() {
  return (
    <RipProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/packs" element={<PacksPage />} />
          <Route path="/pack/:id" element={<PackPage />} />
          <Route path="/vault" element={<VaultPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/referrals" element={<ReferralsPage />} />
          <Route path="/token" element={<TokenPage />} />
          <Route path="/studio" element={<StudioPage />} />
          <Route path="/me" element={<DashboardPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/u/:username" element={<ProfilePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/market" element={<MarketPage />} />
          <Route path="/fairness" element={<FairnessPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </RipProvider>
  )
}

function NotFound() {
  return (
    <div className="py-24 text-center">
      <div className="text-5xl font-bold tracking-tight">404</div>
      <p className="mt-3 text-sm" style={{ color: 'var(--color-muted)' }}>
        That page isn't in the set.
      </p>
      <Link to="/" className="btn btn-primary mt-6">
        Back to packs
      </Link>
    </div>
  )
}
